/**
 * Reducer for flight data receiving
 */
import Constants from '../constants/FlightsConstants';
import { List as IList } from 'immutable';

const initialState = IList();

/**
 * ## auth function
 * @param {Object} state - initialState
 * @param {Object} action - type and data
 */
export default function main (state = initialState, action = null) {
  switch (action.type) {
    /**
     * ### REQUESTS (start)
     */
    case Constants.GET_FLIGHTS_REQUEST:
      return initialState;

    /**
     * ### SUCCESS (request ended with success)
     */
    case Constants.GET_FLIGHTS_SUCCESS:
      if (action.data && action.data.length) {
        return IList(action.data);
      }
      return state;

    /**
     * ### FAILURE (request ended with error)
     */
    case Constants.GET_FLIGHTS_FAILURE:
      return state;

    /**
     * ### CUSTOM client only updates
     */
    case Constants.UPDATE_FLIGHTS:
      return IList(action.data);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/FlightsReducer.js